
























import { Component, Vue, Prop,Inject } from 'vue-property-decorator'
import { isEmpty, toNumber } from 'lodash'
import { searchToWhereUrl } from '@core/utils/jump'

@Component
export default class CouponItem extends Vue {
  @Prop({ default: () => [] }) readonly selfsonitem!: any
  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_selfson_product')
  clickid_selfson_product!: string

  goDetail() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_selfson_product, positionParam: { citycode: this.pageTrackParams.pageParam.citycode,name: this.selfsonitem.spuName,spuid: this.selfsonitem.spuId } })
    const spuType = toNumber(this.selfsonitem.templateType2Id)
    let url = ''
    if (spuType === 601) {
      //景区的businessId字段指的是spuId，spuId字段指的是skuId。推荐接口spuId字段返回有误，这里特殊处理
      url = searchToWhereUrl({ toShop: true, isSpot: true, businessId: this.selfsonitem.spuId })
    } else {
      url = searchToWhereUrl({ spuType, spuId: this.selfsonitem.spuId, businessId: this.selfsonitem.businessId })
    }
    location.href = url
  }

  get distance() {
    if (this.selfsonitem?.distance < 100) {
      return 0.1
    }
    return (this.selfsonitem?.distance / 1000).toFixed(1)
  }
  //隐藏地址方案
  get showCmmdtyAddress() {
    const level4CategoryId = String(this.selfsonitem.level4CategoryId)
    if (!level4CategoryId?.length) {
      return false
    }
    if (level4CategoryId.length < 8) {
      return false
    }
    if (level4CategoryId?.startsWith('101210')) {
      return this.selfsonitem?.templateType2Id === 601
    } else if (level4CategoryId.startsWith('1010')) {
      return false
    }
    return true
  }
}
